// extracted by mini-css-extract-plugin
export var modalBox = "outlinkClickable-module--modalBox--e2523";